import React, { FC } from 'react';

import styled from 'styled-components';

import { RawPicture } from 'components/raw-picture';
import { INavigationTabFragment } from 'generated/sanity-graphql';
import { useAccessibility } from 'state/accessibility';
import { routes } from 'utils/routing';

import { NavLink } from './helpers';
import { IconWrap, NavLinkText } from './styled';

const IconWrapBase = styled(IconWrap)`
  position: relative;
  & img {
    max-width: 20px;
  }
`;

const IconWrapOverlay = styled(IconWrap)`
  position: absolute;
  top: 0;
  left: 0;
`;

const NavLinkWithPictureIcon = styled(NavLink)`
  ${IconWrapOverlay} {
    opacity: 0;
  }
  &.active {
    ${IconWrapBase} > img {
      opacity: 0;
    }
    ${IconWrapOverlay} {
      opacity: 1;
    }
  }
`;

export const SanityNavMobileTab: FC<
  INavigationTabFragment | INavigationTabFragment['launchDarklyAlternateMobileTab']
> = ({ tabIcon, tabIconActive, tabLink }) => {
  const route = tabLink?.link?.locale || routes.base;
  const requiresExactMatch = route === routes.base;

  const { isFullPageModalActive } = useAccessibility();
  return (
    <NavLinkWithPictureIcon
      to={route}
      requiresExactMatch={requiresExactMatch}
      hidden={isFullPageModalActive}
    >
      <IconWrapBase>
        {tabIcon?.locale && <RawPicture image={tabIcon?.locale} alt="" aria-hidden />}
        <IconWrapOverlay>
          {tabIconActive?.locale && <RawPicture image={tabIconActive?.locale} alt="" aria-hidden />}
        </IconWrapOverlay>
      </IconWrapBase>
      <NavLinkText aria-hidden={isFullPageModalActive}>{tabLink?.text?.locale}</NavLinkText>
    </NavLinkWithPictureIcon>
  );
};
